import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import { AssetDetails } from './assetDetails.types';

export const assetDetailsPullQueryBuilder = (document: AssetDetails) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query assetDetailListFeed($siteId: Int!, $disciplineId: Int!, $lastRequested: DateTime!) {
      assetDetailListFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
      ) {
        assetId
        assetMainCategoryName
        assetName
        eAMAssetId
        eAMAssetName
        assetCategoryId
        assetCategoryName
        assetDescription
        installationDate
        namePcsId
        dateCreated
        dateModified
        comment
        site
        discipline
        assetDynamicProperty {
          id
          assetId
          assetPropertyDefinitionId
          name
          value
          assetPropertyValue
          assetPropertyDefinitionValue
          dateCreated
          dateModified
        }
        assetFiles {
          fileId
          assetId
          drawingType
          fileName
          path
          site
          discipline
        }
        etapFields {
          etapId
          assetId
          etapAssetId
          totalEnergy
          workingDistance
          afb
          kv
          site
          discipline
          dateCreated
          dateModified
        }
        parentArea
        areaType
        floorLevel
        lowerBound
        upperBound
        temperature
        corrosion
        humidity
        waterMake
        floorMovement
        backMovement
        sideWallMovement
        aimsAssetID
        aimsAssetName
        eAMAreaId
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc?.site,
        doc?.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};

export default {};
